<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items="items"
  item-value='id'
  item-text='name'
)
</template>

<script>
import picker from '@/mixins/picker'

export default {
  data() {
    return {
      items: [
        { id: 'apartment', name: 'Квартира', color: 'rgb(76, 175, 80)' },
        { id: 'storage', name: 'Кладовка', color: 'rgb(209, 228, 31)' },
        {
          id: 'parking',
          name: 'Парковочное место',
          color: ' rgb(212, 19, 128)'
        },
        { id: 'commercial', name: 'Коммерция', color: 'rgb(13, 0, 255)' },
        {
          id: 'level',
          name: 'Второй уровень квартиры',
          color: 'fill: rgb(242, 255, 0)'
        }
      ]
    }
  },
  mixins: [picker],
  props: {
    label: {
      selected: 'apartment'
    }
  }
}
</script>
